export const materials = [
  {
    id: 16,
    category: "beginner",
    category_label: "입문",
    title: "경매기초반 1강 - 경매일반 & 권리분석",
    description: "경매의 기본 개념과 권리분석의 핵심을 다루는 경매기초반 1강 강의자료입니다. 경매 진행 절차, 법원경매 용어, 등기부등본 기초 해석까지 꼼꼼하게 정리되어 있습니다.",
    file_type: "pdf",
    file_size: "5.8MB",
    file_url: "https://storage.helloreaddy.io/project_files/57b5176f-21a6-4fa5-9700-225c14d3fdcf/f4bcaa3a-3782-47b1-8f26-6a008b72d5ad__250605_1-_.pdf",
    download_count: 0,
    updated_at: "2025-06-05",
    created_at: "2025-06-05",
  },
  {
    id: 1,
    category: "beginner",
    category_label: "입문",
    title: "경매 입문자를 위한 기초 용어와 개념 정리",
    description: "경매 투자를 처음 시작하는 분들을 위한 핵심 용어, 법원경매 진행 절차, 입찰 방법까지 한눈에 정리한 입문 자료입니다.",
    file_type: "pdf",
    file_size: "4.2MB",
    file_url: "",
    download_count: 3840,
    updated_at: "2026-07-15",
    created_at: "2026-07-15",
  },
  {
    id: 2,
    category: "beginner",
    category_label: "입문",
    title: "경매 투자 첫걸음 - 7단계로 배우는 실전 입문",
    description: "물건검색부터 입찰, 잔금납부, 등기이전까지 경매 투자 7단계를 시각적으로 정리한 PPT 자료입니다.",
    file_type: "ppt",
    file_size: "8.5MB",
    file_url: "",
    download_count: 5120,
    updated_at: "2026-07-20",
    created_at: "2026-07-20",
  },
  {
    id: 3,
    category: "rights",
    category_label: "권리분석",
    title: "등기부등본 완전정복 - 말소기준권리 분석 실전 매뉴얼",
    description: "등기부등본 항목별 해석 방법, 말소기준권리 파악, 배당순위 계산까지 실제 사례로 배우는 권리분석 PDF 교재입니다.",
    file_type: "pdf",
    file_size: "12.1MB",
    file_url: "",
    download_count: 2760,
    updated_at: "2026-06-28",
    created_at: "2026-06-28",
  },
  {
    id: 4,
    category: "rights",
    category_label: "권리분석",
    title: "가등기·가처분·압류·근저당 - 복잡권리 해석 가이드",
    description: "등기부에 등장하는 모든 권리들의 의미와 우선순위, 실제 판례를 기반으로 한 권리분석 PPT 강의자료입니다.",
    file_type: "ppt",
    file_size: "6.8MB",
    file_url: "",
    download_count: 1980,
    updated_at: "2026-07-08",
    created_at: "2026-07-08",
  },
  {
    id: 5,
    category: "rights",
    category_label: "권리분석",
    title: "임차인 권리분석 실전 케이스 스터디 20선",
    description: "대항력, 우선변제권, 최우선변제권, 확정일자 등 임차인 권리관계를 실제 판례 20개로 학습하는 PDF 워크북입니다.",
    file_type: "pdf",
    file_size: "9.3MB",
    file_url: "",
    download_count: 1540,
    updated_at: "2026-07-01",
    created_at: "2026-07-01",
  },
  {
    id: 6,
    category: "bidding",
    category_label: "입찰가 산정",
    title: "적정 입찰가 산정 실전 워크시트",
    description: "매각대금, 취득세, 명도비, 수리비 등 모든 비용을 고려한 수익률 기반 입찰가 계산 엑셀 시트가 포함된 PDF 가이드입니다.",
    file_type: "pdf",
    file_size: "3.7MB",
    file_url: "",
    download_count: 4320,
    updated_at: "2026-07-25",
    created_at: "2026-07-25",
  },
  {
    id: 7,
    category: "bidding",
    category_label: "입찰가 산정",
    title: "경쟁자 심리분석과 입찰 당일 전략",
    description: "법원 입찰 현장에서의 경쟁자 유형 분석, 심리전, 최적 입찰가 결정 전략을 담은 PPT 강의자료입니다.",
    file_type: "ppt",
    file_size: "5.2MB",
    file_url: "",
    download_count: 1890,
    updated_at: "2026-06-15",
    created_at: "2026-06-15",
  },
  {
    id: 8,
    category: "eviction",
    category_label: "명도",
    title: "명도실무 A to Z - 임차인 협상부터 강제집행까지",
    description: "명도 절차의 모든 과정과 임차인 유형별 협상 전략, 명도소송 서류 작성법까지 상세히 정리한 PDF 매뉴얼입니다.",
    file_type: "pdf",
    file_size: "7.6MB",
    file_url: "",
    download_count: 2150,
    updated_at: "2026-07-12",
    created_at: "2026-07-12",
  },
  {
    id: 9,
    category: "eviction",
    category_label: "명도",
    title: "명도소송 실전 - 소장 작성부터 판결까지 PPT",
    description: "명도소송 진행 시 필요한 모든 서류와 법원 절차, 실제 소장 샘플이 포함된 실전 PPT 자료입니다.",
    file_type: "ppt",
    file_size: "4.9MB",
    file_url: "",
    download_count: 1320,
    updated_at: "2026-05-20",
    created_at: "2026-05-20",
  },
  {
    id: 10,
    category: "business",
    category_label: "매매사업자 과정",
    title: "매매사업자 세무 완전정복 - 절세 전략 가이드",
    description: "부동산 매매사업자가 반드시 알아야 할 세무 지식, 양도소득세 계산, 합법적 절세 전략을 정리한 PDF 교재입니다.",
    file_type: "pdf",
    file_size: "11.4MB",
    file_url: "",
    download_count: 2980,
    updated_at: "2026-07-30",
    created_at: "2026-07-30",
  },
  {
    id: 11,
    category: "business",
    category_label: "매매사업자 과정",
    title: "자금조달 전략 - 레버리지의 기술",
    description: "주택담보대출, 전세자금대출, 신용대출을 활용한 효율적인 자금조달 방법과 리스크 관리 전략 PPT 자료입니다.",
    file_type: "ppt",
    file_size: "6.1MB",
    file_url: "",
    download_count: 1760,
    updated_at: "2026-06-22",
    created_at: "2026-06-22",
  },
  {
    id: 12,
    category: "business",
    category_label: "매매사업자 과정",
    title: "매매사업자 사업계획서 템플릿",
    description: "부동산 매매사업을 체계적으로 운영하기 위한 사업계획서 양식, 손익 시뮬레이션 시트가 포함된 PDF 템플릿입니다.",
    file_type: "pdf",
    file_size: "2.8MB",
    file_url: "",
    download_count: 3450,
    updated_at: "2026-07-18",
    created_at: "2026-07-18",
  },
  {
    id: 13,
    category: "beginner",
    category_label: "입문",
    title: "법원 경매정보 사이트 200% 활용 가이드",
    description: "대법원 경매정보 사이트에서 필요한 정보를 빠르게 찾고 분석하는 실전 활용법을 스크린샷과 함께 정리한 PDF 자료입니다.",
    file_type: "pdf",
    file_size: "5.4MB",
    file_url: "",
    download_count: 6210,
    updated_at: "2026-07-28",
    created_at: "2026-07-28",
  },
  {
    id: 14,
    category: "bidding",
    category_label: "입찰가 산정",
    title: "수익률 시뮬레이션 - 시나리오별 입찰가 분석",
    description: "보수적/중립적/공격적 시나리오에 따른 수익률 변화를 한눈에 비교할 수 있는 분석 프레임워크 PPT 자료입니다.",
    file_type: "ppt",
    file_size: "7.3MB",
    file_url: "",
    download_count: 2340,
    updated_at: "2026-07-22",
    created_at: "2026-07-22",
  },
  {
    id: 15,
    category: "eviction",
    category_label: "명도",
    title: "임차인 유형별 명도 협상 시나리오",
    description: "생계형 임차인, 상가 임차인, 악성 임차인 등 유형별 맞춤 협상 전략과 실제 협상 사례를 담은 PPT 자료입니다.",
    file_type: "ppt",
    file_size: "5.8MB",
    file_url: "",
    download_count: 1650,
    updated_at: "2026-06-30",
    created_at: "2026-06-30",
  },
];

export const materialCategories = [
  { key: "all", label: "전체" },
  { key: "beginner", label: "입문" },
  { key: "rights", label: "권리분석" },
  { key: "bidding", label: "입찰가 산정" },
  { key: "eviction", label: "명도" },
  { key: "business", label: "매매사업자 과정" },
];